export default "__VITE_ASSET__BTFE4$Oa__"